import { render, staticRenderFns } from "./DashboardEnlace.vue?vue&type=template&id=47bd526b"
import script from "./DashboardEnlace.vue?vue&type=script&lang=js"
export * from "./DashboardEnlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports